




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({})
export default class BindableTimePicker extends Vue {
  @Prop({ default: () => moment() }) public value!: moment.Moment;

  private internalTime: string = "";
  private showTimeMenu: boolean = false;

  @Watch("value")
  protected updateInternalTime() {
    this.internalTime = this.value.format("HH:mm");
  }

  @Watch("internalTime")
  protected updateValue() {
    if (this.value.toISOString() !== this.momentCompatibleTime.toISOString()) {
      this.$emit("input", this.momentCompatibleTime);
    }
  }

  protected get momentCompatibleTime() {
    const splitTime = this.internalTime.split(":").map(x => parseInt(x, 10));
    return this.value.set("hours", splitTime[0]).set("minutes", splitTime[1]);
  }
}
